import _ from 'underscore';
import moment from 'moment';
import angular from 'angular';

import admissionGroupStatService from 'src/api/admissionGroupStat';
import ADMISSION_GROUP_TYPES from 'constants/admissionGroupTypes';

function ManageCtrl($scope, $state, $stateParams, venueService, alertService, ERROR_MESSAGES, sdkUtils, loggerService, $q, $location, dateUtilsService, eventService, userPreferencesService, $timeout, permissionService) { //eslint-disable-line
  $scope.currentDateUTC = $stateParams.date && _.isNumber(parseInt($stateParams.date, 10)) ? moment.utc(parseInt($stateParams.date, 10)) : moment.utc();

  const datePreference = userPreferencesService.getManageCalendarDate();

  if (datePreference && !$stateParams.date) {
    $scope.currentDateUTC = dateUtilsService.toUTCMomentWithoutTime(moment.utc(datePreference, 'x'));
  }

  _initScope();

  $scope.venue = venueService.getCurrentVenue();
  $scope.venueId = $scope.venue.id;
  $scope.venuesPromise = $q.all([
      venueService.getCurrentVenues(),
      _getEvents()
    ])
    .then(results => {
      $scope.venues = results[0];
      $scope.events = results[1];
      $scope.eventsForDropdown = angular.copy($scope.events);
      $scope.eventsForDropdown.unshift({
        name: 'No Filter'
      });
      $scope.eventsIndexedById = _.indexBy($scope.events, 'id');
      $scope.event = $stateParams.eventId ? _.findWhere($scope.events, {
        _id: $stateParams.eventId
      }) : null;
      if (!$scope.event) $scope.event = $scope.eventsForDropdown[0];

      $timeout(() => {
        $scope.initialLoadFinished = true;
      });
    });

  $scope.getAdmissionGroupStats = function(type) {
    $scope.admissionGroupStatsLoading = true;

    return permissionService.canReadPerformanceReports($scope.venue.id)
      .then(hasPermission => {
        if (!hasPermission) {
          $scope.canViewStats = false;
          return null;
        }

        $scope.canViewStats = true;

        return $q.resolve(admissionGroupStatService.findByIdAndVenueId($scope.currentDateUTC.format('x'), $scope.venueId, {
            type
          }))
          .then(result => {
            $scope.admissionGroupStats = result.data;
            $scope.admissionGroupStatsTotals = result.data.totals;
            $scope.admissionGroupStatsByUser = result.data.totalsByUser;
            $scope.admissionGroupStats.modified = moment($scope.admissionGroupStats.modified, 'x');

            $scope.reservationStats = {
              type: ADMISSION_GROUP_TYPES.TABLE,
              totalExpected: $scope.admissionGroupStatsTotals.totalExpectedReservations,
              total: $scope.admissionGroupStatsTotals.totalReservations,
              totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidReservationSubtotal,
              totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidReservationProcessingFeeTotal,
              totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidReservationCommission,
              totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidReservationVenuePayout,
              totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidReservationTotal,
              totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedReservationSpent,
              totalSpent: $scope.admissionGroupStatsTotals.totalReservationSpent,
              totalExpectedGuests: $scope.admissionGroupStatsTotals.totalReservationExpectedGuests,
              totalGuests: $scope.admissionGroupStatsTotals.totalReservationGuests
            };

            $scope.admissionStats = {
              totalExpected: $scope.admissionGroupStatsTotals.totalExpectedAdmissions,
              total: $scope.admissionGroupStatsTotals.totalAdmissions,
              totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionSubtotal,
              totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionProcessingFeeTotal,
              totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionCommission,
              totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionVenuePayout,
              totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidAdmissionTotal,
              totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedAdmissionSpent,
              totalSpent: $scope.admissionGroupStatsTotals.totalAdmissionSpent,
              totalExpectedGuests: $scope.admissionGroupStatsTotals.totalAdmissionExpectedGuests,
              totalGuests: $scope.admissionGroupStatsTotals.totalAdmissionGuests
            };

            $scope.coverStats = {
              type: ADMISSION_GROUP_TYPES.GUEST_LIST,
              totalExpected: $scope.admissionGroupStatsTotals.totalExpectedCovers,
              total: $scope.admissionGroupStatsTotals.totalCovers,
              totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidCoverSubtotal,
              totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidCoverProcessingFeeTotal,
              totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidCoverCommission,
              totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidCoverVenuePayout,
              totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidCoverTotal,
              totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedCoverSpent,
              totalSpent: $scope.admissionGroupStatsTotals.totalCoverSpent,
              totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedCoverGuests,
              totalGuests: $scope.admissionGroupStatsTotals.totalCoverGuests
            };

            $scope.guestlistStats = {
              type: ADMISSION_GROUP_TYPES.GUEST_LIST,
              totalExpected: $scope.admissionGroupStatsTotals.totalExpectedGuestlists,
              total: $scope.admissionGroupStatsTotals.totalGuestlists,
              totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistSubtotal,
              totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistProcessingFeeTotal,
              totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistCommission,
              totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistVenuePayout,
              totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidGuestlistTotal,
              totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedGuestlistSpent,
              totalSpent: $scope.admissionGroupStatsTotals.totalGuestlistSpent,
              totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedGuestlistGuests,
              totalGuests: $scope.admissionGroupStatsTotals.totalGuestlistGuests
            };

            $scope.ticketStats = {
              type: ADMISSION_GROUP_TYPES.TICKET,
              totalExpected: $scope.admissionGroupStatsTotals.totalExpectedTallies,
              total: $scope.admissionGroupStatsTotals.totalTickets,
              totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidTicketSubtotal,
              totalPrepaidProcessingFeeTotal: $scope.admissionGroupStatsTotals.totalPrepaidTicketProcessingFeeTotal,
              totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidTicketCommission,
              totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidTicketVenuePayout,
              totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidTicketTotal,
              totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedTicketSpent,
              totalSpent: $scope.admissionGroupStatsTotals.totalTicketSpent,
              totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedTicketGuests,
              totalGuests: $scope.admissionGroupStatsTotals.totalTicketGuests
            };

            $scope.tallyStats = {
              type: ADMISSION_GROUP_TYPES.TALLY,
              total: $scope.admissionGroupStatsTotals.totalTallies,
              totalPrepaidSubtotal: $scope.admissionGroupStatsTotals.totalPrepaidTallySubtotal,
              totoalPrepaidCommission: $scope.admissionGroupStatsTotals.totalPrepaidTallyCommission,
              totalPrepaidVenuePayout: $scope.admissionGroupStatsTotals.totalPrepaidTallyVenuePayout,
              totalPrepaidTotal: $scope.admissionGroupStatsTotals.totalPrepaidTallyTotal,
              totalExpectedSpent: $scope.admissionGroupStatsTotals.totalExpectedTallySpent,
              totalSpent: $scope.admissionGroupStatsTotals.totalTallySpent,
              totalExpectedGuests: $scope.admissionGroupStatsTotals.totalExpectedTallyGuests,
              totalGuests: $scope.admissionGroupStatsTotals.totalTallyGuests
            };

            $scope.stats = [
              $scope.reservationStats,
              $scope.ticketStats,
              $scope.coverStats
            ];

            $scope.admissionGroupStatsLoading = false;
          });
      });
  };

  $scope.getAdmissionGroupStatsThrottled = _.throttle(() => {
    $scope.getAdmissionGroupStats();
  }, 1000);

  $scope.refreshAdmissionGroupStats = function(e, type) {
    if (e) e.preventDefault();

    $scope.admissionGroupStatsLoading = true;

    $timeout(() => {
      $scope.getAdmissionGroupStats(type);
    }, 300);
  };

  $scope.getAdmissionGroupStats('TOTALS');

  function _initScope() {
    $scope.initialLoadFinished = false;
    $scope.$state = $state;

    $scope.EVENT_DAY_EVENTS = {
      DATE_CHANGED: 'DATE_CHANGED',
      VENUE_CHANGED: 'VENUE_CHANGED',
      EVENT_CHANGED: 'EVENT_CHANGED'
    };

    $scope.dateRangePicker = {
      date: $scope.currentDateUTC
    };

    $scope.$watch('dateRangePicker.date', () => {
      if (!$scope.initialLoadFinished) return;

      $scope.event = null; //remove the event when changing date

      $scope.currentDateUTC = dateUtilsService.toUTCMomentWithoutTime($scope.dateRangePicker.date);

      _updateUrlParams();

      $location.search('eventId', null);

      userPreferencesService.setManageCalendarDate(dateUtilsService.toUTCTimestampWithTime($scope.currentDateUTC));
    });

    $scope.changeVenue = function(venue, $event) {
      if ($event) $event.preventDefault();

      if (!venue) return;

      $scope.venueId = venue.id;
      $scope.venue = venue;

      userPreferencesService.setDefaultVenue(venue.id);

      venueService.setCurrentVenue(venue);

      $location.search('venueId', $scope.venue.id);
    };

    $scope.changeEvent = function(event, $event) {
      if ($event) $event.preventDefault();

      if (!event) return;

      $scope.eventId = event.id;
      $scope.event = event;

      if (event.name !== 'All') $location.search('eventId', $scope.event.id);
      else $location.search('eventId', null);
    };

    _updateUrlParams();
  }

  function _getEvents() {
    if (!$scope.venue) return null;

    return eventService.listByVenueId($scope.venue.id, {
        fields: 'venue(id), date, name, primaryImage, images',
        start: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
        end: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
  }

  function _updateUrlParams() {
    $location.search('date', dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC));
  }
}

ManageCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'venueService',
  'alertService',
  'ERROR_MESSAGES',
  'jsSdk.utils',
  'loggerService',
  '$q',
  '$location',
  'dateUtilsService',
  'jsSdk.event',
  'userPreferencesService',
  '$timeout',
  'permissionService'
];

export default ManageCtrl;



// WEBPACK FOOTER //
// ./src/components/manage/manageCtrl.js